import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import TestArtifacts from './components/TestArtifacts';
import AutomationFramework from './components/AutomationFramework';
import ApiPerformance from './components/ApiPerformance';
import Experience from './components/Experience';
import Certifications from './components/Certifications';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';

function App() {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Skills />
      <Projects selectedProject={selectedProject} setSelectedProject={setSelectedProject} />
      <TestArtifacts />
      <AutomationFramework />
      <ApiPerformance />
      <Experience />
      <Certifications />
      <Blog />
      <Contact />
      <Footer />
      <Chatbot />
    </div>
  );
}

export default App;
